export enum GlobalConfigFuelEnum{
    diesel = "diesel",
    gasoline = "gasoline"
}
export enum GlobalConfigDistanceEnum{
    km = "km",
    mile = "mile"
}

export enum GlobalConfigCashEnum{
    usd = "usd",
    eur = "eur",
    tr = "try"
}